import { tokenNotValid } from '../constants/httpStatus';
import { authentication } from '../components/authentication';
import errors from '../constants/errors';
import backendPathname from './backendUrl';
import { FetchOptions, UrlParam } from './interfaces';

import { AnyObject } from '../constants/interfaces';
import { ApiCalls } from './apiCalls';
import { nortadaLogger } from '../components/common/logger';

export const addSearchParamsToPathname = (pathname: string, urlParams: UrlParam[], encode: boolean = true) =>
  encode
    ? `${pathname}?${new URLSearchParams(urlParams).toString()}`
    : `${pathname}?${decodeURIComponent(new URLSearchParams(urlParams).toString())}`;

export const addParams = (method: 'POST' | 'PUT', params: AnyObject) => ({
  method,
  body: JSON.stringify(params),
  headers: { 'content-type': 'application/json' }
});

export function fetchWithTokenRefresh(pathname: string, options?: FetchOptions): Promise<Response> {
  if (options?.urlParams) {
    pathname = addSearchParamsToPathname(pathname, options.urlParams);
  }
  pathname = backendPathname(pathname);
  const { signal } = ApiCalls.getInstance().createConnection();

  return new Promise((resolve, reject) => {
    function fetchDataWithRetry(retries = 1): Promise<Response | void> {
      return fetch(pathname, { ...(options || {}), method: options?.method ?? 'GET', signal })
        .then(res => {
          const tokenIsValid = res.status !== tokenNotValid.status;

          if (tokenIsValid) {
            resolve(res);
            return;
          }
          if (!tokenIsValid && retries > 0) {
            authentication
              .updateToken()
              .then(updatedToken => {
                if (updatedToken) {
                  return fetchDataWithRetry(retries - 1);
                }
                throw new Error(errors.tokenWasNotUpdated);
              })
              .catch(e => {
                nortadaLogger.error(e);
                authentication.logout({ text: tokenNotValid.message, severity: 'info' });
              });
          } else {
            authentication.logout({ text: tokenNotValid.message, severity: 'info' });
          }
        })
        .catch(e => {
          reject(e);
        });
    }
    fetchDataWithRetry();
  });
}
